/* eslint-disable react/prop-types */
import React from 'react'
import { Field } from 'redux-form'

import ReduxFormCheckbox from '@cred/react-basic-form-fields/reduxForm/Checkbox'

const CheckboxRedux = (props) => {
  const { className, ...rest } = props
  return <Field component={ReduxFormCheckbox} className={className} {...rest} />
}

export default CheckboxRedux
